/**
 * French postal code: exactly 5 digits. Single source of truth for the zip
 * regex + user-facing message shared across the RDV public + manager surfaces
 * and the departure-address schemas (#622).
 */
export const FR_ZIP_REGEX = /^\d{5}$/;
export const FR_ZIP_MESSAGE = "Le code postal en France est une suite de cinq chiffres";
//# sourceMappingURL=frZip.js.map